/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetRegionsByPointModel,
  IGetRegionsByPointRequest,
  IMappers,
  IGetRegionsByPointResponse,
  IGetRegionsByPointResponseError,
  TGetRegionsByPointResponse,
} from './types';

const defaultConfig: TGetRegionsByPointModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'geo',
  pathApi: '/v1/get-regions-by-point/',
  hostType: 'api',
} as TGetRegionsByPointModel;

function createGetRegionsByPointModel(parameters: IGetRegionsByPointRequest): TGetRegionsByPointModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetRegionsByPointOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetRegionsByPointRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetRegionsByPoint<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetRegionsByPointOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetRegionsByPointResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetRegionsByPointModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetRegionsByPointResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetRegionsByPointResponseError);
    }
  }

  return { response, statusCode } as TGetRegionsByPointResponse;
}

export { defaultConfig, createGetRegionsByPointModel, fetchGetRegionsByPoint };
